import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("fx_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export function apiError(e, fallback = "Something went wrong") {
    return formatApiErrorDetail(e?.response?.data?.detail) || e?.message || fallback;
}

// Date helpers — IST display
const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

export function fmtDate(iso) {
    if (!iso) return "";
    const d = new Date(iso.length === 10 ? iso + "T00:00:00" : iso);
    const day = String(d.getDate()).padStart(2, "0");
    return `${day} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

export function fmtTime(iso) {
    if (!iso) return "";
    const d = new Date(iso);
    if (isNaN(d.getTime())) return "";
    return d.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: false, timeZone: "Asia/Kolkata" });
}

export function fmtDateTime(iso) {
    if (!iso) return "";
    return `${fmtDate(iso)} · ${fmtTime(iso)}`;
}

/** ₹ Indian-locale currency formatter. Handles null/undefined/NaN gracefully. */
const _INR_2 = new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 2 });
const _INR_0 = new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 });
export function fmtInr(value, { decimals = 2 } = {}) {
    const n = typeof value === "string" ? parseFloat(value) : value;
    if (n === null || n === undefined || Number.isNaN(n)) return "—";
    return (decimals === 0 ? _INR_0 : _INR_2).format(n);
}
